<template>
  <q-tab-panels animated class="tab-panels bg-white text-off-black col" :value="value">
    <slot />
  </q-tab-panels>
</template>

<script>
export default {
  name: 'TabPanels',
  props: {
    value: String,
  },
};
</script>

<style lang="stylus" scoped>
.q-tab-panels {
  max-width: 100%;
  margin-bottom: 64px;

  @media (min-width: 640px) {
    margin-bottom: 0;
  }

  @media (min-width: $breakpoint-sm) {
    border-radius: 0 0 4px 4px;
  }
}
</style>

<style lang="stylus">
.ios-notch-bottom .tab-panels {
  margin-bottom: calc(22px + env(safe-area-inset-bottom));

  @media (min-width: 640px) {
    margin-bottom: 0;
  }
}
</style>
